import { CommonModule, isPlatformBrowser } from "@angular/common";
import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { Router, RouterLink, RouterLinkActive } from "@angular/router";
import { Web3WalletService } from "../../../services/web3-wallet.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { UserNotificationDto } from "../../../dtos/user-notification.dto";
import { NotificationsService } from "../../../services/notifications.service";
import { EthPricePipe } from "../../../pipes/eth-price.pipe";
import { TimeAgoPipe } from "../../../pipes/time-ago.pipe";
import { NotificationType } from "../../../enums/notification.type";
import { CreaturesService } from "../../../services/creatures.service";

@Component({
  selector: 'header-component',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    FormsModule,
    EthPricePipe,
    TimeAgoPipe
  ]
})
export class HeaderComponent implements OnInit, AfterViewInit {

  public lang: string | null = null;
  public isWalletConnected: boolean = false;
  public walletAddress: string | null = null;
  public showNotificationCenter: boolean = false;

  public notifications: UserNotificationDto[] | null = null;
  public newNotificationCount: number = 0;

  public notificationType: typeof NotificationType = NotificationType;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private readonly web3WalletService: Web3WalletService,
    private readonly cdr: ChangeDetectorRef,
    private readonly route: Router,
    private readonly translateService: TranslateService,
    private readonly notificationsService: NotificationsService,
    private readonly creaturesService: CreaturesService
  ) {
    this.lang = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe((event) => {
      this.lang = event.lang;
    })

    if (isPlatformBrowser(this.platformId)) {
      this.web3WalletService.onChangeUser.subscribe((user) => {
        this.isWalletConnected = this.web3WalletService.isWalletConnected();
        this.walletAddress = user ? this.shortenWalletAddress(user.walletAddress!) : null;
        if (user) {
          this.cdr.markForCheck();
          if (user.token) {
            setTimeout(() => {
              this.notificationsService.getByFilter({ page: 0, pageSize: 50 }).subscribe((notifications) => {

                if (notifications.length > 0) {
                  notifications.forEach((notification) => {
                    if (notification.type === NotificationType.BreedingIsReady) {
                      const creature1Id = notification.params['creature_1_id'];
                      const creature2Id = notification.params['creature_2_id'];
                      notification.continueBreedingLink = `/my-creatures/view/${creature1Id}/continue-breeding/${creature2Id}/${notification.breedingOrderId}`
                    }
                  });
                }

                this.notifications = notifications;

                this.newNotificationCount = this.notifications?.filter(n => !n.isRead).length || 0;

                this.cdr.markForCheck();
              });
            }, 1000);
          }
        }
      });
    }
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const script = document.createElement('script');
      script.src = '/assets/js/menu.script.js';
      script.type = 'text/javascript';
      script.async = true;
      document.body.appendChild(script);
    }
  }

  private shortenWalletAddress(address: string): string {
    if (address.length <= 10) {
      return address;
    }
    const start = address.slice(0, 5);
    const end = address.slice(-5);
    return `${start}...${end}`;
  }

  public onChangeLanguage(event: any): void {
    let lang = event.target.value;
    let pathParts = this.route.url.split('/');
    let path = [location.origin, lang, ...pathParts.slice(2)].join('/');
    location.href = path;
  }

  public openNotificationCenter(): void {
    this.showNotificationCenter = !this.showNotificationCenter;

    if (this.notifications && this.notifications.length > 0) {
      const newCreatureNotifications = this.notifications!.filter(n => n.creatureId && !n.creature);
      console.log('New creature notifications:', newCreatureNotifications.length);
      if (newCreatureNotifications.length > 0) {
        const creatureIds = newCreatureNotifications.map(n => n.creatureId!);
        const uniqueCreatureIds = Array.from(new Set(creatureIds));
        uniqueCreatureIds.forEach(id => {
          const alreadyExists = this.notifications?.find(n => n.creatureId === id && n.creature);
          if (!alreadyExists) {
            this.creaturesService.getById(id).subscribe(creature => {
              this.notifications?.filter(n => n.creatureId === creature.id && !n.creature).forEach(notification => {
                notification.creature = creature;
              });
              this.cdr.markForCheck();
            });
          } else {
            this.notifications?.filter(n => n.creatureId === id && !n.creature).forEach(notification => {
              notification.creature = alreadyExists.creature;
            });
            this.cdr.markForCheck();
          }
        });
      }
    }

    if (this.showNotificationCenter) {
      let lastNotificationId = this.notifications?.length ? this.notifications[0].id : null;
      if (lastNotificationId) {
        this.notificationsService.setLastRead(lastNotificationId).subscribe(() => {
          if (this.notifications) {
            this.notifications.forEach(notification => notification.isRead = true);

            this.cdr.markForCheck();
          }
        });
      }
    }
  }
}